import type { ProfileFeatureConfig } from './type';

export const profile: ProfileFeatureConfig = {
    inverseNameOrder: false,
    inverseNameOrderNationalities: ['HU', 'CN', 'KR', 'KP'],
};
